import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import store from "./store/index";
import { RATES_VERSION } from "./store/rates-slice";
import "./index.css";
import App from "./App";

// Check if rates version has changed and force cache refresh if needed
const STORAGE_KEY = 'amity_rates_version';
const storedVersion = localStorage.getItem(STORAGE_KEY);

// Clean up cache-busting parameter if present (from previous reload)
if (window.location.search.includes('_cb=')) {
  const url = new URL(window.location.href);
  url.searchParams.delete('_cb');
  window.history.replaceState({}, '', url.toString());
}

if (storedVersion !== RATES_VERSION) {
  // Clear all localStorage to ensure fresh data
  localStorage.clear();
  // Store new version
  localStorage.setItem(STORAGE_KEY, RATES_VERSION);
  // Force a hard reload to bypass browser cache
  // Using replace to avoid adding to history, and adding timestamp to bypass cache
  const separator = window.location.href.includes('?') ? '&' : '?';
  window.location.replace(window.location.href + separator + '_cb=' + Date.now());
} else {
  // Only render if version matches (prevents rendering during reload)
  const root = ReactDOM.createRoot(document.getElementById("root"));

  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
}
